const classicData = `<h2>The three greatest things you learn from traveling</h2>

\t<p>Like all the great things on earth traveling teaches us by example. Here are some of the most precious lessons I’ve learned over the years of traveling.</p>

\t<figure class="media">
\t\t<oembed url="https://www.youtube.com/watch?v=CB70skVw3nU"></oembed>
\t</figure>

\t<h3>Appreciation of diversity</h3>

\t<p>Getting used to an entirely different culture can be challenging. While it’s also nice to learn about cultures online or from books, nothing comes close to experiencing cultural diversity in person. You learn to appreciate each and every single one of the differences while you become more culturally fluid.</p>

\t<blockquote>
\t\t<p>The real voyage of discovery consists not in seeking new landscapes, but having new eyes.</p>
\t\t<p><strong>Marcel Proust</strong></p>
\t</blockquote>

\t<h3>Improvisation</h3>

\t<p>Life doesn't allow us to execute every single plan perfectly. This especially seems to be the case when you travel. You plan it down to every minute with a big checklist; but when it comes to executing it, something always comes up and you’re left with your improvising skills. You learn to adapt as you go. Here’s how my travel checklist looks now:</p>

\t<ul>
\t\t<li>buy the ticket</li>
\t\t<li>start your adventure</li>
\t</ul>

\t<figure class="image image-style-side"><img src="https://www.telegraph.co.uk/content/dam/Travel/2017/July/Bagan-travel-getty.jpg?imwidth=450" alt="Three Monks walking on ancient temple.">
\t\t<figcaption>Leaving your comfort zone might lead you to such beautiful sceneries like this one.</figcaption>
\t</figure>

\t<h3>Confidence</h3>

\t<p>Going to a new place can be quite terrifying. While change and uncertainty makes us scared, traveling teaches us how ridiculous it is to be afraid of something before it happens. The moment you face your fear and see there was nothing to be afraid of, is the moment you discover bliss.</p>
`;
export default classicData;
